import PropTypes from "prop-types";
import React from "react";

const Cell = (props) => {
  const { content, isHeader = false } = props;

  if (isHeader) {
    return (
      <th scope="col" role="columnheader" id={content.key}>
        {content}
      </th>
    );
  }

  return <td>{content}</td>;
};
Cell.propTypes = {
  content: PropTypes.shape().isRequired,
  isHeader: PropTypes.bool,
};

export default Cell;
